import React from 'react'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import IconButton from 'particles/Button/IconButton'
import { IconName, IndicatorColor } from 'particles/Icon'

interface GridCellExpandProps {
    onClick: () => void
    highlighted: boolean
    isDisabled: boolean
    icon: IconName
    indicatorColor?: IndicatorColor
}
interface HighlightCellProp extends GridRenderCellParams {
    onClick: () => void
    isDisabled: boolean
    icon: IconName
    indicatorColor?: IndicatorColor
}

const GridCellExpand = React.memo(function GridCellExpand(props: GridCellExpandProps) {
    const { highlighted, onClick, isDisabled, icon, indicatorColor } = props
    const iconColor = indicatorColor ? undefined : highlighted ? 'primary' : 'neutral'

    return (
        <IconButton
            size="m"
            color={iconColor}
            indicatorColor={indicatorColor}
            form="icon"
            icon={icon}
            iconForm={indicatorColor || highlighted ? 'fill' : 'regular'}
            onClick={onClick}
            isDisabled={isDisabled}
        />
    )
})

export const HighlightCell = (params: HighlightCellProp) => {
    return (
        <GridCellExpand
            onClick={params.onClick}
            highlighted={params.row.highlighted}
            isDisabled={params.isDisabled}
            icon={params.icon}
            indicatorColor={params.indicatorColor}
        />
    )
}

export default HighlightCell
